// Description: Page to add new sheets to the system
// Updated: 18/09/2025

// React Components
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Material UI Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { FormControl, Typography, TextField, Select, MenuItem, Button, FormHelperText, Divider } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';

// Components and Functions from the project
import ModalR from "../../components/Modals/ModalR";
import ThemeColors from "../../components/ThemeColors/ThemeColors";

import { GetVariables } from "../../api/aws/Listagens/GetVariables";
import { PostListagens } from "../../api/aws/Listagens/PostListagens";
import { id } from "date-fns/locale";
import Loading from "../../components/Loading/Loading";

import CampaignModal from "../../components/Modals/CampaignModal";
import { notify } from "../../utils/utils";
import use123zapStore from "../../context/123zapStore";
import ReturnToLastPage from "../../components/ChannelAdd/ReturnToLastPage";
import StepIndicator from "../../components/DynamicForm/StepIndicator";

// Render Form to add new sheets
function SheetsForm({ setDataR, copyRespostas, setCopyRespostas, setErrors, errors, setCurrentStep, setErroLoading, uuidClient }) {

  // States to control the form fields
  const [formErros, setFormErros] = useState({});
  const [setFormateList, setListagensOptions] = useState([]);
  const [formateSelected, setFormateSelected] = useState();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);

  const listOptions = [
    { id: 2, title: "Google planilhas" }
  ];

  const [respostas, setRespostas] = useState({
    title: copyRespostas?.title || "",
    desc: copyRespostas?.desc || "",
    url: copyRespostas?.url || "",
    formatSheets: "Google planilhas",
    deleteDuplicatedVariables: copyRespostas?.deleteDuplicatedVariables || ""
  });

  async function CheckSheetsPermission(e) {
    e.preventDefault();

    setLoading(true);

    try {

      if (!respostas.title) {
        formErros.title = "Campo obrigatório"
        return;
      };

      if (!respostas.desc) {
        formErros.desc = "Campo obrigatório";
        return;
      };

      if (!respostas.url && respostas.formatSheets === "Google planilhas") {
        formErros.url = "Campo obrigatório";
        return;
      };

      if (!respostas.formatSheets) {
        formErros.formatSheets = "Campo obrigatório";
        return;
      };

      const token = localStorage.getItem('jwt_token');
      const clientId = localStorage.getItem('idToken');

      if (!token) throw new Error('Token de autenticação não encontrado');
      if (!clientId) throw new Error('ID do cliente não encontrado');

      if (respostas.formatSheets === "Google planilhas") {

        const response = await axios.get(process.env.REACT_APP_BACKEND_AWS_URL + '/sheets/google/check?url=' + respostas.url, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
            'Client_ID': clientId
          }
        });

        const items = Object.entries(response.data["item_example"]).map(([field, value]) => ({
          field,
          value
        })).filter((item) => item.field !== "row_number");

        if (items.length > 0) {
          setDataR(items);
          setCurrentStep(2);
          setErroLoading(false);
        } else {
          setErroLoading(true);
          formErros.url = "Link inválido";
          setErrors(formErros);
        }

      }

    } catch (error) {
      console.error('Erro ao obter dados da API:', error);
      setLoading(false);
      setErroLoading(true);
      formErros.url = "Ocorreu um erro com o link";
      setErrors(formErros);
    } finally {
      setCopyRespostas(respostas);
      setErrors(formErros);
      setLoading(false);
    }

  }

  const handleInputChange = (name, value) => {
    setRespostas((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <Grid item xs={12} md={12} style={{ 'background': '#FFF', 'borderRadius': '12px', 'padding': '15px' }}>
      <form onSubmit={CheckSheetsPermission}>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <TextField
            variant="outlined"
            name="title"
            label="Digite um nome para identificar a listagem"
            value={respostas.title || ""}
            onChange={(e) => handleInputChange("title", e.target.value)}
            sx={{ background: errors.title ? '#F8D6D3' : respostas.title ? '#F5F3FF' : '#F9F9F9', marginTop: '5px', borderRadius: '12px', '& .css-8zvu95-MuiFormLabel-root-MuiInputLabel-root': { top: '-10%' } }}
            error={errors.title}
            InputLabelProps={{
              style: { color: ThemeColors.gray50 }
            }}
          />
          {errors.title && <FormHelperText style={{ color: "red" }}>{errors.title}</FormHelperText>}
        </FormControl>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <TextField
            name="desc"
            label="Digite uma descrição para a listagem"
            sx={{ background: errors.desc ? '#F8D6D3' : respostas.desc ? '#F5F3FF' : '#F9F9F9', marginTop: '5px', borderRadius: '12px', '& .css-8zvu95-MuiFormLabel-root-MuiInputLabel-root': { top: '-10%' } }}
            value={respostas.desc || ""}
            onChange={(e) => handleInputChange("desc", e.target.value)}
            error={errors.desc}
            InputLabelProps={{
              style: { color: ThemeColors.gray50 }
            }}
          />
          {errors.desc && <FormHelperText style={{ color: "red" }}>{errors.desc}</FormHelperText>}
        </FormControl>
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <TextField
            name="url"
            label="Digite ou cole aqui o link da sua planilha:"
            sx={{ background: errors.url ? '#F8D6D3' : respostas.url ? '#F5F3FF' : '#F9F9F9', marginTop: '5px', borderRadius: '12px', '& .css-8zvu95-MuiFormLabel-root-MuiInputLabel-root': { top: '-10%' } }}
            value={respostas.url || ""}
            onChange={(e) => handleInputChange("url", e.target.value)}
            error={errors.url}
            fullWidth
            InputLabelProps={{
              style: { color: ThemeColors.gray50 }
            }}
          />
          {errors.url && <FormHelperText style={{ color: "red" }}>{errors.url}</FormHelperText>}
        </FormControl>
        <Button
          variant="contained"
          type="submit"
          fullWidth
          sx={{ padding: '15px', marginTop: '10px', fontSize: '16px' }}
          disabled={loading}
        >
          Carregar dados
        </Button>
      </form>
    </Grid>
  );
}

function DataDisplayTable({ data, setData, handleSubmit, variablesOfTemplate, page, setPage }) {
  // State to control the form fields
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [values, setValues] = useState({});

  // UseEffect para evitar a re-renderização das páginas
  useEffect(() => {
    const startIndex = page * rowsPerPage;
    const currentItems = data.slice(startIndex, startIndex + rowsPerPage);
    const newInputValues = {};

    currentItems.forEach((item, i) => {
      const absoluteIndex = startIndex + i;
      newInputValues[absoluteIndex] = item.variable || '';
    })
    setValues(newInputValues);
  }, [data, page])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };

  const handleChangeSelect = (value, index) => {
    console.log(values, 'values');
    console.log(data, 'data');

    setValues({
      ...values,
      [index]: value === "Selecione" ? null : value
    });

    setData(prevData =>
      prevData.map((dataItem, dataIndex) =>
        dataIndex === index ? { ...dataItem, variable: value === "Selecione" ? null : value } : dataItem
      )
    );
  };

  const verifyIfVariableIsSelected = (variable) => {

    if (variable === 'WhatsApp' || variable === 'Email') {
      return false;
    }
    return data.some(item => item.variable === variable);
  }

  const renderSelects = () => {
    const startIndex = page * rowsPerPage;
    const currentItems = data.slice(startIndex, startIndex + rowsPerPage);

    return currentItems.map((item, index) => {
      const absoluteIndex = startIndex + index;
      return (
        <>
          {
            item !== null && item !== undefined && item !== "" && /^\s*[a-zA-Z]/.test(item.field) ? (
              <TableRow key={absoluteIndex}>
                <TableCell>{item.field}</TableCell>
                <TableCell>
                  <Select
                    labelId={"type_send_id" + index}
                    id={"type_send" + index}
                    value={values[absoluteIndex] ? values[absoluteIndex] : "Selecione"}
                    onChange={(e) => {
                      const selectedValue = e.target.value;

                      if (
                        selectedValue === "WhatsApp" &&
                        !(typeof item.field === "string" && /^\s*[a-zA-Z]/.test(item.field))
                      ) {
                        notify("Alert", "Essa coluna não é valida", true);
                        return;
                      }

                      handleChangeSelect(selectedValue, absoluteIndex);
                    }}
                    fullWidth
                    style={{ boxShadow: 'none' }}
                    MenuProps={{
                      PaperProps: {
                        style: { boxShadow: 'none', border: '1px solid #d3d3d3' }
                      },
                    }}
                    size="small"
                    sx={{
                      background: values[absoluteIndex] === "Selecione" || !values[absoluteIndex]
                        ? '#f9f9f9'
                        : '#f5f3ff',
                      marginTop: '5px',
                      borderRadius: '12px',
                      fontSize: { xs: '11px', sm: '12px', xl: '14px' }
                    }}
                  >
                    <MenuItem sx={{ fontSize: { xs: '11px', sm: '12px', xl: '14px' } }} value="Selecione">Selecione</MenuItem>
                    {Object.values(variablesOfTemplate).flat().map((value) => (
                      <MenuItem
                        sx={{ fontSize: { xs: '11px', sm: '12px', xl: '14px' } }}
                        key={value}
                        value={value}
                        disabled={verifyIfVariableIsSelected(value)}
                      >
                        {value}
                      </MenuItem>
                    ))}
                  </Select>
                </TableCell>
              </TableRow>
            ) : null
          }
        </>

      )
    })
  }

  return (
    <Grid item xs={12} md={12} style={{ 'background': '#FFF', 'borderRadius': '12px' }}>
      <form onSubmit={handleSubmit}>
        <TableContainer style={{ marginBottom: '10px', padding: '0px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: { xs: '11px', sm: '12px', xl: '14px' } }}>CAMPO</TableCell>
                <TableCell sx={{ fontSize: { xs: '11px', sm: '12px', xl: '14px' } }}>REPRESENTA</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {renderSelects()}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Button variant="contained" color="primary" type="submit" fullWidth sx={{ padding: '15px', marginTop: '10px', fontSize: '16px' }}>
          Enviar
        </Button>
      </form>
    </Grid>
  );
}

function PageAddSheets() {

  // State to authenticate control
  const userAuthenticated = use123zapStore((state) => state.userAuthenticated);
  const userInfo = use123zapStore((state) => state.userInfo);
  const setUserInfo = use123zapStore((state) => state.setUserInfo);
  const planoAtual = use123zapStore((state) => state.planoAtual);
  const setAlreadyFetchSheets = use123zapStore((state) => state.setAlreadyFetchSheets);
  const navigate = useNavigate();

  const creatingCampaignWithHelpMode = JSON.parse(sessionStorage.getItem("creating_campaign")) || null;

  // State to control the form fields
  const [copyRespostas, setCopyRespostas] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [countEmptyVariables, setCountEmptyVariables] = useState(0);
  const [dataR, setDataR] = useState([]);
  const [errors, setErrors] = useState({});
  const [fieldChannelSelected, setFieldChannelSelected] = useState(null);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [verifyEmptyVariables, setVerifyEmptyVariables] = useState(false);
  const [erroLoading, setErroLoading] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
  const [padronizationPage, setPadronizationPage] = useState(0);
  const [openModalCampaign, setOpenModalCampaign] = useState(false);

  useEffect(() => {
    if (
      planoAtual !== 'FreeZap' &&
      planoAtual !== 'StartZap' &&
      planoAtual !== 'ProZap' &&
      planoAtual !== 'UltraZap' &&
      planoAtual !== null
    ) {
      navigate('/acesso-restrito');
    }
  }, [planoAtual]);

  useEffect(() => {
    if (userInfo['UUID']) {
      fetchData();
    }
  }, [userInfo]);

  const fetchData = async () => {
    try {

      let info = { 'uuid_client': userInfo['UUID'], 'id': userInfo['EMAIL'], 'token': userInfo['TOKEN'] };
      info = JSON.stringify(info);

      const translations = {
        "Personal_information": "Informações Pessoais",
        "Contact": "Contato",
        "Address": "Endereço",
        "Financial_References": "Referências Financeiras"
      };

      const resultJson = await GetVariables();

      console.log('resultJson', resultJson);

      const result = resultJson.data.reduce((acc, item) => {
        const category = translations[item.category] || item.category;
        if (!acc[category]) {
          acc[category] = [];
        }

        acc[category].push(item.variableName);

        return acc;

      }, {});

      setVariablesOfTemplate(result);

    } catch (error) {
      console.error('Error fetching data from API:', error);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    if (Object.keys(variablesOfTemplate).length !== 0 && currentStep === 2) {
      setDataR((prev) =>
        prev.map((item) => {
          const normalize = (str) => str?.trim().toLowerCase();
          const findVariable = Object.values(variablesOfTemplate).flat().find((variable) => normalize(variable) === normalize(item.field));

          if (findVariable) {
            return {
              ...item,
              variable: findVariable
            }
          } else {
            return {
              ...item
            }
          }
        })
      );

    }
  }, [variablesOfTemplate, currentStep])

  const preSubmit = (e) => {

    e.preventDefault();

    const newErrors = {};
    if (!copyRespostas.title) newErrors.title = "Campo obrigatório";
    if (!copyRespostas.desc) newErrors.desc = "Campo obrigatório";
    if (!copyRespostas.url && copyRespostas.formatSheets === "Google planilhas") newErrors.url = "Campo obrigatório";
    if (!copyRespostas.formatSheets) newErrors.formatSheets = "Campo obrigatório";
    if (!copyRespostas.deleteDuplicatedVariables) newErrors.deleteDuplicatedVariables = "Campo obrigatório";

    setErrors(newErrors);

    let variables = dataR.map((item) => {
      return {
        field: item.field,
        variable: item.variable
      }
    });

    const hasEmptyVariable = variables.some((item) => !item.variable);
    const countEmptyVariable = variables.filter((item) => !item.variable).length;

    setVerifyEmptyVariables(hasEmptyVariable);
    setCountEmptyVariables(countEmptyVariable);

    const variablesWhatsApp = variables.filter((item) => item.variable === 'WhatsApp');
    const variablesEmail = variables.filter((item) => item.variable === 'Email');

    if (variablesWhatsApp.length > 0 || variablesEmail.length > 0) {
      setFieldChannelSelected(true);
    } else {
      setFieldChannelSelected(false);
      setOpenModalConfirm(true);
      return false;
    }

    setOpenModalConfirm(true);

  }

  useEffect(() => {
    if (
      copyRespostas.title === "" ||
      copyRespostas.desc === "" ||
      copyRespostas.formatSheets === "" ||
      copyRespostas.url === ""
    ) {
      notify("Error", "Preencha todos os campos obrigatórios", true);
    }

    if (!fieldChannelSelected && dataR.length > 0) {
      notify("Error", "WhatsApp ou Email não selecionado", true);
    }

    if (verifyEmptyVariables) {
      notify(
        "Alert",
        `Existem ${countEmptyVariables} campos sem seleção`,
        true
      );
    }

    if (erroLoading) {
      notify(
        "Error",
        "Lembre-se de compartilhar a planilha google com o e-mail: planilhas-n8n@projeto-brio-n8n.iam.gserviceaccount.com",
        true
      );
    }
  }, [
    copyRespostas,
    fieldChannelSelected,
    dataR,
    verifyEmptyVariables,
    countEmptyVariables,
    erroLoading,
  ]);

  const handleSubmit = async () => {

    let variables = dataR.map((item) => {
      return {
        field: item.field,
        variable: item.variable === "Selecione" ? null : item.variable
      }
    });

    let data = { ...copyRespostas, variables, 'uuid_client': userInfo['UUID'], 'id': userInfo['EMAIL'], 'token': userInfo['TOKEN'] };
    const response = await PostListagens(data);

    if (response.status === "success") {

      if (creatingCampaignWithHelpMode) {
        setOpenModalConfirm(false);
        setOpenModalCampaign(true);
      } else {
        navigate('/listagens');
      }
      setAlreadyFetchSheets(false);
      notify("Success", "Listagem adicionada com sucesso!", true);

    } else {

      //alert('Erro ao enviar os dados');

    }

  };

  const handleCloseModalConfirm = () => {
    setOpenModalConfirm(false);
  }

  const steps = [
    {
      stepNumber: 1,
      title: "Formulário",
      description: (
        <span>
          Nessa etapa você vai escolher um nome para identificação, criar uma
          descrição para a listagem, colar o link da sua planilha Google ou
          selecionar a API e, em seguida, clicar em "Carregar dados" para
          visualizar os campos da listagem.
        </span>
      ),
    },
    {
      stepNumber: 2,
      title: "Padronização",
      description: (
        <span>
          Para cada campo, selecione o que ele representa.
        </span>
      ),
    },
  ];

  if (showLoading) {
    return <Loading open={true} />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: { xs: "100vh", sm: "100vh" },
        backgroundColor: { xs: "#fff", sm: "#F1F5F9" },
        paddingBottom: { xs: "none", sm: "30px" }
      }}
    >
      <ReturnToLastPage />

      <Box sx={{
        alignSelf: "center",
        background: "#FFF",
        borderRadius: "",
        boxShadow: {
          xs: "none",
          sm: "0 2px 4px -1px rgba(0, 0, 0, 0.1)",
        },
        minHeight: {
          xs: "100vh",
          sm: "100%",
          md: "583.2px",
          lg: "583.2px",
          xl: "583.2px",
        },
        minWidth: {
          xs: "100%",
          sm: "100%",
          md: "736.2px",
          lg: "736.2px",
          xl: "736.2px",
        },
        maxWidth: {
          xs: "100%",
          sm: "100%",
          md: "736.2px",
          lg: "736.2px",
          xl: "736.2px",
        },
        padding: "30px",
        borderRadius: {
          xs: "0",
          sm: ".5rem",
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: "10px", sm: "15px" },
      }}>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "100%",
            flexDirection: { xs: "column-reverse", sm: "row" },
            gap: { xs: "30px", sm: "0px" },
          }}
        >
          <StepIndicator currentStep={currentStep} steps={steps} />
        </Box>

        <Divider
          sx={{
            width: "100%",
            borderColor: "gray",
            marginBottom: { xs: "0px", sm: "15px" },
          }}
        />

        <Typography
          sx={{
            fontSize: { xs: "16px", sm: "1.125rem" },
            fontWeight: 700,
            color: "#000",
          }}
        >
          {steps[currentStep - 1].title}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "12px", sm: "14px" },
            color: "#E923B",
            marginBottom: "19px",
            textAlign: "center",
            maxWidth: { xs: "100%", sm: "80%" },
          }}
        >
          {steps[currentStep - 1].description}
        </Typography>
        {
          currentStep === 1 ? (
            <SheetsForm setDataR={setDataR} copyRespostas={copyRespostas} setCopyRespostas={setCopyRespostas} setErrors={setErrors} errors={errors} setCurrentStep={setCurrentStep} setErroLoading={setErroLoading} uuidClient={userInfo['UUID']} />
          ) : currentStep === 2 && dataR.length > 0 ? (
            <DataDisplayTable data={dataR} setData={setDataR} handleSubmit={preSubmit} variablesOfTemplate={variablesOfTemplate} page={padronizationPage} setPage={setPadronizationPage} />
          ) : null
        }
      </Box>

      <ModalR
        cancelText={!fieldChannelSelected ? "Voltar" : "Mudei de ideia"}
        color={ThemeColors.purple500}
        confirmText={!fieldChannelSelected ? "" : "Sim, tenho certeza"}
        subTitle={!fieldChannelSelected ? "Selecione a coluna onde esteja os WhatsApps ou Emails em sua listagem"
          : "Você deseja finalizar a importação da listagem?"}
        isOpen={openModalConfirm}
        onClose={handleCloseModalConfirm}
        onConfirm={handleSubmit}
        title={!fieldChannelSelected ? "Alguns campos são obrigatórios"
          : verifyEmptyVariables ? `Existem ${countEmptyVariables} campos sem seleção` : "Finalizar importação"}
        emoji={verifyEmptyVariables ? "emoji04" : "emoji01"}
        iconColor={ThemeColors.purple400}
      />
      <CampaignModal
        cancelText="Adicionar mais uma listagem"
        confirmText="Retornar ao formulário"
        subTitle={"Percebemos que você está configurando uma campanha. Gostaria de retornar ao formulário?"}
        isOpen={openModalCampaign}
        onClose={() => setOpenModalCampaign(false)}
        onCancel={() => navigate("/listagens/adicionar")}
        onConfirm={() => (navigate("/campanhas/adicionar"), sessionStorage.setItem("ReturToCampaign", true))}
        title={"Listagem adicionada com sucesso"}
        iconColor={ThemeColors.purple400}
      />
    </Box>
  );
}

export default PageAddSheets;